<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-card>
          <h3 class="text-center">Add a Blog Post</h3>
          <form @submit.prevent="uploadBlog">
            <b-form-group>
              <div hidden><b-icon-cloud-check></b-icon-cloud-check> Saved</div>
              <b-form-group>
                <b-button
                  class="ml-3"
                  variant="dark"
                  @click="triggerFileClick()"
                  ><b-icon-image></b-icon-image> Add a cover photo</b-button
                >
              </b-form-group>
              <img
                v-if="coverimagelink.length != 0"
                :src="coverimagelink"
                class="image-attachment mb-3"
              />
              <b-form-group>
                <b-form-input
                  type="text"
                  v-model="blogpost.title"
                  class="title-input"
                  placeholder="Title..."
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <b-form-input
                  type="text"
                  v-model="blogpost.subtitle"
                  class="subtitle-input"
                  placeholder="Enter Subtitle(Optional)"
                ></b-form-input>
              </b-form-group>

              <b-overlay :show="uploadingcoverimage">
                <template #overlay>
                  <div class="text-center">
                    <b-icon-file-image
                      font-scale="3"
                      animation="throb"
                    ></b-icon-file-image>
                    <p>Uploading Cover Image...</p>
                  </div>
                </template>
                <b-form-group>
                  <input
                    type="file"
                    ref="coverphoto"
                    @input="handleImage"
                    class="cover-photo-input"
                  />
                </b-form-group>
              </b-overlay>

              <b-form-group>
                <vue2-tinymce-editor
                  v-model="blogpost.body"
                ></vue2-tinymce-editor>
              </b-form-group>

              <b-form-group
                label="Add Tags relevant to the POST. Tags could be keyword used in the post"
              >
                <b-form-tags v-model="blogpost.tags"></b-form-tags>
              </b-form-group>

              <div v-if="saved" class="alert alert-success p-3">
                Changes has been saved
              </div>
              <b-row>
                <b-col class="text-right">
                  <b-overlay
                    :show="saving"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class=""
                  >
                    <b-button
                      :disabled="validate"
                      variant="primary"
                      @click="saveDraft"
                      >{{
                        saving == true
                          ? "Saving..."
                          : saved == true
                          ? "Saved"
                          : "Save"
                      }}
                      <b-icon-box-arrow-in-down-left></b-icon-box-arrow-in-down-left
                    ></b-button>
                  </b-overlay>
                </b-col>
                <b-col class="text-left">
                  <b-overlay
                    :show="publishing"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class=""
                  >
                    <b-button
                      :disabled="validate"
                      variant="success"
                      @click="publishPost"
                      >Publish
                      <b-icon-box-arrow-in-up-right></b-icon-box-arrow-in-up-right
                    ></b-button>
                  </b-overlay>
                </b-col>
              </b-row>
            </b-form-group>
          </form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import store from "@/store";
import { mapActions, mapState } from "vuex";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";

export default {
  components: {
    Vue2TinymceEditor
  },
  data() {
    return {
      uploadingcoverimage: false,
      coverimagelink: "",
      saving: false,
      saved: false,
      blogpost: this.getpost(),
      publishing: false,
      published: false
    };
  },
  created() {
    this.setImageDirectory("blogimages");
    this.coverimagelink = this.blogdraftforedit.coverphoto;

    this.blogpost = {
      title: this.blogdraftforedit.title,
      subtitle: this.blogdraftforedit.subtitle,
      body: this.blogdraftforedit.body,
      draftid: this.blogdraftforedit.track_id,
      tags: JSON.parse(this.blogdraftforedit.tags),
      coverphoto: this.blogdraftforedit.coverphoto,
      writer: this.$store.state.loginmaster.details.fullname,
      writerid: this.$store.state.loginmaster.details.trackid
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("admin/fetchBlogdraft");
    next();
  },
  methods: {
    ...mapActions("admin", [
      "saveBlogdraftChanges",
      "publishBlogpost",
      "setImageDirectory"
    ]),
    triggerFileClick() {
      this.$refs.coverphoto.click();
    },
    handleImage() {
      this.uploadingcoverimage = true;
      let coverimage = this.$refs.coverphoto.files[0];
      let formData = new FormData();
      formData.append("image", coverimage);
      formData.append("environment", this.environ);
      let apilink =
        this.environ == "development"
          ? "http://localhost/quicktest/src/apis/blogImageHandler.php"
          : "https://quicktest.futavilla.com/apis/blogImageHandler.php";
      axios
        .post(apilink, formData, {
          header: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.uploadingcoverimage = false;
          this.$bvModal
            .msgBoxOk("Image Uploaded Successfully.", {
              title: "Image Uploaded",
              size: "xs",
              centered: true
            })
            .then(() => {});
          console.log(response.data);
          //this.setFile(response.data.url);
          this.coverimagelink = response.data.url;
          this.blogpost.coverphoto = response.data.url;
        })
        .catch(() => {
          this.$bvModal
            .msgBoxOk(
              "Check your Network Connection. Could not upload Image.",
              {
                title: "No Network Connection",
                size: "xs",
                centered: true
              }
            )
            .then(() => {
              this.uploadingcoverimage = false;
            });
          //console.log(error);
        });
    },
    getpost() {
      return {
        coverphoto: "",
        title: "",
        subtitle: "",
        body: "",
        tags: [],
        writer: this.$store.state.loginmaster.details.fullname,
        writerid: this.$store.state.loginmaster.details.trackid,
        draftid: this.$route.params.trackid
      };
    },
    saveDraft() {
      this.saving = true;
      this.saveBlogdraftChanges(this.blogpost).then(() => {
        this.saving = false;
        this.saved = true;
      });
    },
    publishPost() {
      this.publishing = true;
      this.publishBlogpost(this.blogpost).then(() => {
        this.publishing = false;
        this.blogpost.title = "";
        this.blogpost.subtitle = "";
        this.blogpost.body = "";
        this.blogpost.coverphoto = "";
        this.blogpost.tags = [];

        this.$router.push({
          name: "listblogdrafts",
          query: { page: 1 }
        });
      });
    },
    saveDraftChanges() {
      this.saving = true;
      this.saveBlogdraftChanges(this.blogpost).then(() => {
        this.saving = false;
        this.saved = true;
      });
    }
  },
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      environ: state => state.loginmaster.environ,
      blogdraftforedit: state => state.admin.blogdraftforedit[0]
    }),
    validate() {
      if (
        this.blogpost.title.length == 0 ||
        this.blogpost.coverphoto.length == 0 ||
        this.blogpost.body.length == 0 ||
        this.blogpost.tags.length == 0
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.title-input {
  font-size: 3rem;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  border: 0px;
  border-radius: 0px;
}
.title-input:focus {
  border: 0px;
}
.subtitle-input {
  font-size: 2rem;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  border: 0px;
  border-radius: 0px;
}
.cover-photo-input {
  font-size: 2rem;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  border: 0px;
  border-radius: 0px;
  height: 10rem;
  display: none;
}
.ck-editor__editable_inline {
  min-height: 500px !important;
}
@media screen and (max-width: 768px) {
  .image-attachment {
    height: 200px;
  }
}

@media screen and (min-width: 768px) {
  .image-attachment {
    height: 300px;
  }
}
</style>
